<template>
	<div>
		<v-card outlined id="dropzone" ref="dzone" tabindex="0" :title="$t('common.dragAndDrop')" width="100%" :class="[
			'px-2 py-6 d-flex flex-column justify-center align-center',
			!dragover || 'elevation-6',
		]" @click.stop="$refs.upload.click()">
			<input ref="upload" accept="audio/*" :multiple="multiple" id="fileUpload" type="file" class="d-none" />
			<span v-if="file == null || file.length == 0" class="d-flex flex-column">
				<v-icon class="mx-auto" x-large color="secondary">mdi-folder-open</v-icon>{{ $t('common.dragAndDrop') }}
			</span>
			<span v-else class="d-flex flex-wrap" style="gap: 10px">
				<v-chip :key="i" v-for="(f, i) in file" label>{{ f.name }}</v-chip>
			</span>
		</v-card>
		<v-card-actions v-if="file && file.length > 0">
			<v-spacer />
			<v-btn text color="error" @click.stop="file = []">
				<v-icon left>mdi-close</v-icon>Quitar
			</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
export default {
	// internal properties
	// formUpload: boolean = false
	// dragover: boolean = false
	
	props: ['value', 'multiple', 'rules'],
	computed: {
		file: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},

	data: () => ({
		dragover: false,
		formUpload: false,
		minAudioDuration: 5, // Duracion minima en segundos para los audios

	}),
	mounted() {
		// to register listeners, we have to know the
		// html elements
		const dropzone = this.$refs.dzone.$el;
		const fileupload = this.$refs.upload;
		// register listeners on your dropzone / v-sheet
		if (dropzone) {
			// register all drag & drop event listeners
			dropzone.addEventListener("dragenter", (e) => {
				e.preventDefault();
				this.dragover = true;
			});
			dropzone.addEventListener("dragleave", (e) => {
				e.preventDefault();
				this.dragover = false;
			});
			dropzone.addEventListener("dragover", (e) => {
				e.preventDefault();
				this.dragover = true;
			});
			dropzone.addEventListener("drop", (e) => {
				e.preventDefault();
				const dragevent = e;
				if (dragevent.dataTransfer) {
					this.filesSelected(dragevent.dataTransfer.files);
				}
			});
			dropzone.addEventListener("keypress", (e) => {
				e.preventDefault();
				const keyEvent = e;
				if (keyEvent.key === "Enter") {
					if (fileupload) fileupload.click();
				}
			});
			// register listeners on the file input
			if (fileupload) {
				fileupload.addEventListener("change", (e) => {
					const target = e.target;
					if (target.files) {
						this.filesSelected(target.files);
					}
				});
			}
		}
	},
	methods: {
		async filesSelected(fileList) {
			this.dragover = false;

			const files = Array.from(fileList);
			const audioFiles = files.filter(file => file.type.startsWith('audio/'));


			const validAudioFiles = [];
			for (const file of audioFiles) {
				try{
					const filetype = file.type
					if (!filetype || !filetype.startsWith('audio/')) {
						this.$emit('file-invalid', { file, reason: 'not-audio', type: filetype });

					}
					else {
						const duration = await this.getAudioDuration(file);
						if (duration >= this.minAudioDuration) {
							validAudioFiles.push(file);
						} else {
							this.$emit('file-invalid', { file, reason: 'too-short', duration });
						}
					}
				} catch (error) {
					console.error('Error reading file type:', error);
				}
			}

			// Include non-audio files
			const finalFiles = files.filter(f => !f.type.startsWith('audio/')).concat(validAudioFiles);
			this.file = finalFiles;
		},

		getAudioDuration(file) {
			return new Promise((resolve, reject) => {
				const audio = document.createElement('audio');
				audio.preload = 'metadata';
				audio.onloadedmetadata = () => {
					window.URL.revokeObjectURL(audio.src);
					resolve(audio.duration);
				};

				audio.onerror = (e) => {
					reject(new Error('Cannot load audio file'));
				};

				audio.src = URL.createObjectURL(file);
			});
		},

	},
	/**
	 * upload event...
	 */
	// @Emit()
	// filesSelected(fileList: FileList) {
	//   this.dragover = false
	// }
};
</script>